<template>
    <div class="event">
        <div class="scroll">
            <h5>今日事件记录</h5>
            <p>123<span>条</span></p>
            <div class="events">
                <div class="box" v-for="item in events" :key="item.id">
                    <p>{{item.name}}</p>
                    <span>{{item.concent}}</span>
                    <span class="eTime">{{item.time}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            events:[
                {
                    id:1,
                    time:'1小时前',
                    name:'最近发生了一件大事',
                    concent:'震工有地工有地工肝地工地肛地有地工圾工圾革晨圧 震工有地工地肛地有地工圾工圾革晨圧',
                },
                {
                    id:2,
                    time:'1小时前',
                    name:'最近发生了一件大事',
                    concent:'震工有地工有地工肝地工地肛地有地工圾工圾革晨圧 震工有地工地肛地有地工圾工圾革晨圧',
                },
                {
                    id:3,
                    time:'1小时前',
                    name:'最近发生了一件大事',
                    concent:'震工有地工有地工肝地工地肛地有地工圾工圾革晨圧 震工有地工地肛地有地工圾工圾革晨圧', 
                },
            ]
        }
    }
}
</script>

<style lang='less' scoped>
    .event{
        width: 100%;
        height: 340rem;
        height: 30vh;
        background-color: #fff;
        padding:20rem 12rem 20rem 24rem;
        .scroll{
            width: 100%;
            height: 100%;
            padding-right: 12rem;
            
            h5{
                color: #333;
                font-weight: bold;
                font-size: 18rem;
                padding-bottom: 20rem;
            }
            &>p{
                color: #0D94FF;
                font-weight: bold;
                font-size: 24rem;
                padding-bottom: 10rem;
                border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                span{
                    font-size: 18rem;
                    color: #333;
                }
            }
            .events{
                width: 100%;
                height: 211rem;
                overflow-y: scroll;
                overflow-x: hidden;
                &>.box{
                    cursor: pointer;
                    position: relative;
                    padding: 15rem 0;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    p{
                        color: #333;
                        font-size: 18rem;
                        font-weight: 400;
                        padding-bottom: 10rem;
                    }
                    span{
                        display: inline-block;
                        width: 80%;
                        color: #999;
                        font-size: 14rem;
                        font-weight: 400;
                        line-height: 21rem;
                    }
                    .eTime{
                        position: absolute;
                        left:22vw;
                        top: 4vh;
                    }
                }
            }
            ::-webkit-scrollbar{
                width: 5rem;
                height: 1px;
            }
            ::-webkit-scrollbar-thumb{
                background-color: #fff;
                border-radius: 3rem;
                border: 1rem solid #ccc;
            }
        }
        
    }
</style>